import { render, staticRenderFns } from "./Login2FA.vue?vue&type=template&id=b36463ba&scoped=true"
import script from "./Login2FA.vue?vue&type=script&lang=js"
export * from "./Login2FA.vue?vue&type=script&lang=js"
import style0 from "./Login2FA.vue?vue&type=style&index=0&id=b36463ba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36463ba",
  null
  
)

export default component.exports